import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EditBusinessInfoComponent } from '../edit-business-info.component';

@Component({
  selector: 'txp-new-brand',
  templateUrl: './new-brand.component.html',
  styleUrls: ['./new-brand.component.scss'],
  standalone: true,
  imports: [EditBusinessInfoComponent],
})
export class NewBrandComponent {
  isCreate;
  constructor(public dialogRef: MatDialogRef<NewBrandComponent>) {
    this.isCreate = true;
  }

  onClose(data) {
    this.dialogRef.close(data);
  }
}
